export default {
    title: 'Kategorie erstellen',
    name: 'Bezeichnung',
    description: 'Beschreibung',
    createCategory: 'Kategorie erstellen',
    createCategorySuccess: 'Die Kategorie wurde erfolgreich erstellt.',
    createCategoryError: 'Die Kategorie konnte nicht erstellt werden.'
}